import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../ServicePage.css';

function UIUXDesign() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const designServices = [
        "User Experience (UX) Research",
        "User Interface (UI) Design", 
        "Wireframing & Prototyping",
        "Information Architecture",
        "User Journey Mapping",
        "Design System Creation",
        "Usability Testing",
        "Accessibility Design (WCAG)"
    ];

    const tools = [
        "Figma & Sketch",
        "Adobe Creative Suite",
        "InVision & Marvel",
        "Principle & Framer",
        "Miro & Whimsical",
        "UserTesting platform",
        "Hotjar & Google Analytics",
        "Zeplin & Abstract"
    ];

    const deliverables = [
        "User personas & scenarios",
        "Wireframes & flowcharts",
        "High-fidelity mockups",
        "Interactive prototypes",
        "Component libraries",
        "Style guides",
        "Developer handoff specs",
        "Usability test reports"
    ];

    const specializations = [
        "Mobile app UI/UX",
        "Web application design",
        "E-commerce experiences",
        "SaaS platform design",
        "Dashboard & admin panels",
        "Landing page optimization",
        "Responsive design",
        "Design system architecture"
    ];

    return (
        <div className="service-page">
            <Container>
                <div className="service-header">
                    <h1 className="service-title gradient-text">UI/UX Design</h1>
                    <p className="service-description">
                        Design di interfacce intuitive e user experience ottimizzate.
                        Ricerca utente, prototipazione e design system per prodotti digitali eccellenti.
                    </p>
                </div>

                <Row className="mb-5">
                    <Col lg={8}>
                            <div className="service-description">
                                <h3>UI/UX Design Professionale</h3>
                                <p>
                                    Progetto esperienze digitali coinvolgenti e interfacce intuitive che mettono 
                                    l'utente al centro. Attraverso ricerca, prototipazione e testing, creo 
                                    soluzioni design che aumentano conversioni e soddisfazione utente.
                                </p>
                                <p>
                                    Dal concept iniziale al design system completo, applico metodologie 
                                    user-centered e best practices di usabilità per creare prodotti 
                                    digitali che gli utenti amano utilizzare.
                                </p>
                            </div>

                            <div className="design-services-section">
                                <h3>Servizi Design</h3>
                                <Row>
                                    {designServices.map((service, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">✨</span>
                                                {service}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="tools-section">
                                <h3>Tools & Piattaforme</h3>
                                <Row>
                                    {tools.map((tool, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🛠️</span>
                                                {tool}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <Alert variant="success" className="design-alert">
                                <h5><i className="fas fa-users"></i> User-Centered Design</h5>
                                <p>
                                    Metodologia design thinking con focus su ricerca utente, personas,
                                    journey mapping e testing iterativo per creare esperienze che risolvono 
                                    reali problemi degli utenti.
                                </p>
                            </Alert>

                            <div className="deliverables-section">
                                <h3>Deliverables</h3>
                                <Row>
                                    {deliverables.map((deliverable, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">📋</span>
                                                {deliverable}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="specializations-section">
                                <h3>Specializzazioni</h3>
                                <Row>
                                    {specializations.map((spec, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🎯</span>
                                                {spec}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="service-process">
                                <h3>Processo Design</h3>
                                <div className="process-steps">
                                    <div className="process-step-item">
                                        <div className="step-number">1</div>
                                        <div className="step-text">Discovery & Research utente</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">2</div>
                                        <div className="step-text">Information Architecture & Wireframing</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">3</div>
                                        <div className="step-text">Visual Design & Prototipazione</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">4</div>
                                        <div className="step-text">Testing & Iterazione</div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4}>
                            <div className="service-sidebar">
                                <Card className="service-info-card">
                                    <Card.Body>
                                        <h4>Expertise Design</h4>
                                        <ul>
                                            <li>User Experience Research</li>
                                            <li>Interface Design</li>
                                            <li>Design Systems</li>
                                            <li>Accessibility (A11Y)</li>
                                            <li>Conversion Optimization</li>
                                            <li>Mobile-first Design</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <Card className="methodology-card">
                                    <Card.Body>
                                        <h4>🔄 Metodologie</h4>
                                        <ul>
                                            <li>Design Thinking</li>
                                            <li>User-Centered Design</li>
                                            <li>Agile UX</li>
                                            <li>Lean UX</li>
                                            <li>Design Sprint</li>
                                            <li>Atomic Design</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <Card className="research-card">
                                    <Card.Body className="text-center">
                                        <h5>🔍 Research Methods</h5>
                                        <ul style={{textAlign: 'left'}}>
                                            <li>User interviews</li>
                                            <li>Surveys & questionnaires</li>
                                            <li>Usability testing</li>
                                            <li>A/B testing</li>
                                            <li>Card sorting</li>
                                            <li>Analytics analysis</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <Card className="accessibility-card">
                                    <Card.Body className="text-center">
                                        <h5>♿ Accessibility</h5>
                                        <ul style={{textAlign: 'left'}}>
                                            <li>WCAG 2.1 compliance</li>
                                            <li>Screen reader optimization</li>
                                            <li>Keyboard navigation</li>
                                            <li>Color contrast testing</li>
                                            <li>Inclusive design</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <div className="cta-section">
                                    <a href="#contact" className="btn-gradient w-100 mb-3">
                                        <span>Richiedi Preventivo Design</span>
                                    </a>
                                    <Link to="/services" className="btn btn-outline-primary w-100">
                                        Torna ai Servizi
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
            </Container>
        </div>
    );
}

export default UIUXDesign;